import { render } from "./BasicInput.vue?vue&type=template&id=fcc90846&scoped=true"
import script from "./BasicInput.vue?vue&type=script&lang=js"
export * from "./BasicInput.vue?vue&type=script&lang=js"

import "./BasicInput.vue?vue&type=style&index=0&id=fcc90846&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcc90846"]])

export default __exports__